import WidgetEventListResourcePagingResultModel from '../../generated/types/model/resource/WidgetEventListResourcePagingResultModel';

export default class WidgetEventListResourcePagingResultViewModel extends WidgetEventListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
